import "./TeamDevelopmentActionPlanObjectiveCompScores.less";
import * as React from "react";
import { CompDevSubCompetencyResult, IObjectiveWithCompetency } from "@atman/business";
import { CompetencyResultLabel } from "../../../CompetencyResultLabel";
import { SmallTitleContentBlock } from "../../../SmallTitleContentBlock";
import { observer } from "mobx-react";

export interface ITeamDevelopmentActionPlanObjectiveCompScoresProps {
    objective: IObjectiveWithCompetency;
}
export const TeamDevelopmentActionPlanObjectiveCompScores: React.FC<ITeamDevelopmentActionPlanObjectiveCompScoresProps> =
    observer((props) => {
        const { objective } = props;

        const isImproveAssessment = objective.data instanceof CompDevSubCompetencyResult;

        return (
            <div className="TeamDevelopmentActionPlanObjectiveCompScores">
                {objective.competency && (
                    <SmallTitleContentBlock
                        title={
                            isImproveAssessment
                                ? "competencyDevelopment.competencyToDevelop".localize()
                                : "competencyDevelopment.competencyToLeverage".localize()
                        }
                    >
                        <CompetencyResultLabel competency={objective.competency} />
                    </SmallTitleContentBlock>
                )}
                {isImproveAssessment && (
                    <SmallTitleContentBlock title={"competencyDevelopment.subCompetencyToDevelop".localize()}>
                        <CompetencyResultLabel competency={objective.data as CompDevSubCompetencyResult} />
                    </SmallTitleContentBlock>
                )}
            </div>
        );
    });
